export default __webpack_public_path__ + "static/media/ly.5b82a613.svg";